import { NoPrint } from '@dataplace.ai/ui-components/atoms'
import React, { ReactNode } from 'react'
import { useOverviewData } from '../hooks/useOverviewData'

export const ConditionalNoPrint = ({ children }: {children: ReactNode | ReactNode[]}): JSX.Element => {
  const {
    dataLoaded, hasUnlimitedCredits, subscriptionLoaded,
  } = useOverviewData()

  return subscriptionLoaded && !hasUnlimitedCredits && !dataLoaded
    ? <NoPrint>{children}</NoPrint>
    : <>{children}</>
}
